export default __webpack_public_path__ + "static/isms-afc8e20b88441c19c463617bf6ff3d20.png";